import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'react-bootstrap';
import { Image } from '@components/common';
import classNames from 'classnames';

class Header extends PureComponent {
	render() {
		const { step } = this.props;

		return (
			<Fragment>
				<div className="bg-primary padding-top-10 padding-bottom-10">
					<Grid>
						<div className="flex flex-align-items-center">
							<div>
								<Image
									className="height-35 margin-right-20"
									src="/images/logo.png"
								/>
							</div>
							<div className="font-medium-italic">Serving those who protect</div>
						</div>
					</Grid>
				</div>

				<div className="bg-white border-solid border-1 border-gray-mystic">
					<Grid className="padding-xs-0-1">
						<div className="flex flex-align-items-bottom" id="quickpay-steps">
							<div className={classNames('quickpay-steps-item', {
								active  : step === 1,
								visited : step >= 1,
							})}
							>
								<div>INVOICE INFO</div>
							</div>

							<div className={classNames('padding-left-20 padding-right-20 padding-xs-0-1 height-40', {
								'quickpay-border-blue' : step >= 2,
							})}
							>
								<i className="rkf rkf-chevron-right color-gray-silver" />
							</div>

							<div className={classNames('quickpay-steps-item', {
								active  : step === 2,
								visited : step >= 2,
							})}
							>
								<div>PAYMENT METHOD</div>
							</div>

							<div className={classNames('padding-left-20 padding-right-20 padding-xs-0-1 height-40', {
								'quickpay-border-blue' : step >= 3,
							})}
							>
								<i className="rkf rkf-chevron-right color-gray-silver" />
							</div>

							<div className={classNames('quickpay-steps-item', {
								active  : step === 3,
								visited : step === 3,
							})}
							>
								<div>DONE</div>
							</div>
						</div>
					</Grid>
				</div>
			</Fragment>
		);
	}
}

Header.propTypes = {
	step : PropTypes.number,
};

Header.defaultProps = {
	step : 1,
};

export default Header;
